import { applyMiddleware, createStore } from 'redux';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';
import rootReducer from './reducers';
import LoaderMiddleware from './loaderMiddleware';
import AttributesMiddleware from './attributesMiddleware';

const { environment } = window['runConfig'];

const reduxMiddlewares = [thunk, LoaderMiddleware, AttributesMiddleware];
let middleWares = applyMiddleware(...reduxMiddlewares);
if (['development', 'stage'].includes(environment)) {
  middleWares = composeWithDevTools(middleWares);
}
const store = createStore(rootReducer, middleWares);

export default store;
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
